import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=ba0781da&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=ba0781da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba0781da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ba0781da')) {
      api.createRecord('ba0781da', component.options)
    } else {
      api.reload('ba0781da', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=ba0781da&scoped=true&", function () {
      api.rerender('ba0781da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2O3w47xxe97Od/JS/comp/PopupDialog.vue"
export default component.exports